import { render, staticRenderFns } from "./ProjectCreateProductsAndPrices.vue?vue&type=template&id=4bc61f73&"
import script from "./ProjectCreateProductsAndPrices.vue?vue&type=script&lang=ts&"
export * from "./ProjectCreateProductsAndPrices.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectCreateProductsAndPrices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports